/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Mon Dec 30 2024
 **/

import { useEffect, useRef, useState } from "react";

export default function useClickOutside() {
	const [isClicked, setIsClicked] = useState(false);
	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const handleDocumentMouseDown = (e: MouseEvent) =>
			!ref.current?.contains(e.target as Node) && setIsClicked(false);
		document.addEventListener("mousedown", handleDocumentMouseDown);
		return () => document.removeEventListener("mousedown", handleDocumentMouseDown);
	}, []);

	const toggleClicked = () => setIsClicked((prev) => !prev);

	return { ref, isClicked, toggleClicked };
}
